import {
  TrendyolOrderProduct,
  trendyolOrderProductFromResponse,
} from './TrendyolOrderProduct';
import { TrendyolOrderStatus } from './TrendyolOrderStatus';

export interface TrendyolOrder {
  id: number;
  trendyolID: number;
  cargoTrackingNumber: string;
  customerFullName: string;
  total: number;
  shipmentImages: string[];
  products: TrendyolOrderProduct[];
  status: TrendyolOrderStatus;
  createdAt: Date;
}

export const trendyolOrderFromResponse = (
  responseData: any,
): TrendyolOrder => ({
  id: responseData.id,
  trendyolID: responseData.trendyol_id,
  cargoTrackingNumber: responseData.cargo_tracking_number,
  customerFullName: responseData.customer_full_name,
  total: responseData.total,
  shipmentImages: responseData.shipment_images,
  products: (responseData.products ?? []).map((product: any) =>
    trendyolOrderProductFromResponse(product),
  ),
  status: responseData.status,
  createdAt: new Date(responseData.created_at),
});
